import React from "react";

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="px-4 sm:px-6 py-3 sm:py-4 pb-[max(0.75rem,env(safe-area-inset-bottom))] bg-white border-t border-gray-200 relative z-40">
          <p className="text-xs text-gray-500 text-center">
            © {currentYear} Unisoft Solutions. All rights reserved.
          </p>
    </footer>
  );
};

export default Footer;
